module.exports = __webpack_public_path__ + "img/AGP.62939146.png";